import { render, staticRenderFns } from "./ButtonUserType.vue?vue&type=template&id=fa7bba92&scoped=true&"
import script from "./ButtonUserType.vue?vue&type=script&lang=js&"
export * from "./ButtonUserType.vue?vue&type=script&lang=js&"
import style0 from "./ButtonUserType.vue?vue&type=style&index=0&id=fa7bba92&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa7bba92",
  null
  
)

export default component.exports